export const urlWithBasePath = (url: string) => {
    const basePath = process.env.CXP_APP_BASE_PATH || '/';
    if (url && !url.startsWith('/')) {
        url = `/${url}`;
    }
    return url.startsWith(basePath) ? url : `${basePath}${url}`.replace(/\/+/g, '/');
};

export const imageUrl = (file: string) => urlWithBasePath(file);

export const linkUrl = (path: string) => {
    return `${urlWithBasePath(path)}`;
};
